import React, { Component } from "react";
import dotenv from 'dotenv';
import Helper from '../Devices/DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    t_get_all_projects
} from "../reducers/dev";

import { Card, Button, Row, Col } from 'react-bootstrap';
import "./project.css"
import { Link } from 'react-router-dom'
import Chart from "../Devices/DevServices/Chart"
import ProjectCards from "./ProjectCards"

///run/user/1000/gvfs/sftp:host=xtal.asia,user=venus/home/venus/docker/4028-29-30_wifi_api_react/app/frontend/src/Devices/DevServices/Chart.jsx

dotenv.config();

class PageProjects extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }
  
  componentDidMount(){
    this.props.t_get_all_projects()
    //if (this.props.user) this.props.thunkTest(this.props.user.accessToken)
    //if (this.props.user) this.props.t_get_all_projects()  

  }



  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //Get Projects by user_role
    
    //If No projects
    if (!this.props.dev.all_projects) return <div className="">No any Project yet...</div>

    return (
    <div className="">

    <h4>Projects</h4>

    {/* all_projects */}
    <ProjectCards 
    all_projects = {this.props.dev.all_projects} 
    />


    <div className="container">

    <div className="row">


    </div>

    </div>

      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    t_get_all_projects
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageProjects);